module.exports = "/images/interaction-icon.svg?384cfc68cf43f5309b2193218de7b1ea";